module.exports = __webpack_public_path__ + "img/napravlen-mobile-4.dd3b03bf.png";